import { AdminApi } from 'stylemix-vue-admin'
import payWithBancontact from '../taxi-payments-js/bancontact'
import payWithCard from '../taxi-payments-js/card'

export default class OrdersApi extends AdminApi {
  constructor(parameters) {
    super('orders', parameters)
  }

  /**
   * @inheritDoc
   */
  all(config = {}) {
    return this.submit('get', `/${this.endpoint}/my`, null, config)
  }

  /**
   * Calculate order
   *
   * @param {Object} order
   * @param {Object} data
   * @param {String} data.method
   * @param {Object} config
   */
  calculate(order, data = {}, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/calculate`,
      data,
      config,
    )
  }

  /**
   * Perform pay operation for order
   *
   * @param {Object} order
   * @param {String} method
   * @param {Object} data
   * @param {String} data.card_id
   * @param {Object} config
   */
  pay(order, method, data = {}, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/pay`,
      { ...data, method },
      config,
    )
  }
}

export function createPayApi(order) {
  const ordersApi = new OrdersApi()

  return (method, payload) => {
    if (method === 'cash') {
      return ordersApi.pay(order, method)
    }

    if (method === 'bancontact') {
      return ordersApi
        .pay(order, method, {
          intent: true,
          return_url_params: { postMessage: true },
        })
        .then(source => {
          return payWithBancontact(source)
        })
    }

    if (method === 'card') {
      const { card_id, stripe } = payload
      return ordersApi.pay(order, method, { card_id }).then(intent => {
        return payWithCard(intent, card_id, stripe)
      })
    }

    return Promise.reject(`Unsupported method ${method}`)
  }
}
